<template>
  <el-main>
    <div class="tool" shadow="never">
      <el-upload
        class="upload"
        action=""
        :multiple="false"
        :show-file-list="false"
        accept="csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :http-request="httpRequest"
        v-loading.fullscreen.lock="fileloading"
        element-loading-text="数据加载中..."
      >
        <el-button size="large" type="primary"
          ><i class="el-icon-upload"></i>选择文件</el-button
        >
      </el-upload>

      <!-- 占位 -->
      <div style="flex: 1">
        <label
          >总记录数：{{ totalNum }} 条,保存成功：{{ saveNum }}  条，保存失败：{{
            errorNum
          }} 条</label
        >
      </div>

      <el-button
        size="large"
        type="primary"
        @click="savelist"
        element-loading-text="数据保存中..."
        ><i class="el-icon-save"></i>全部保存</el-button
      >
    </div>

    <!-- 表格 -->
    <CadresInfoTable
      :cadresviewlist="cadresInfo"
      :editEnabled="false"
    ></CadresInfoTable>
  </el-main>
</template>



<script>
import XLSX from "xlsx";
const moment = require("moment");
const changeDate = (timeNum) => {
  let _type = typeof timeNum;
  if (_type == "number") {
    const d = timeNum - 1;
    const t = Math.round((d - Math.floor(d)) * 24 * 60 * 60);
    return moment(new Date(1900, 0, d, 0, 0, t)).format("YYYY-MM-DD");
  } else if (_type == "string") {
    // 尝试转换为日期类型
    let pDate = new Date(timeNum);
    if (pDate == "Invalid Date") {
      return "格式错误";
    } else {
      return timeNum;
    }
  } else {
    return "";
  }
};

import { CadresInfoTable } from "@/components/CadresInfo";

export default {
  name: "ImportInfo",
  components: {
    CadresInfoTable,
  },

  data() {
    return {
      fileloading: false,
      // 老干部信息，数组
      cadresInfo: [],
      nations: [],
      organizations: [],

      keyOfcolName: {
        // id: "id",
        name: "姓名",
        sex: "性别",
        birthday: "出生日期",
        // age: "age",
        // nation: null,
        nationname: "民族",
        natives: "籍贯",
        political: "政治面貌",
        papers: "证件",
        papersnum: "证件号码",
        partydate: "入党时间",
        workdate: "参加革命工作时间",
        workperiod: "参加革命时期",
        workunit: "原工作单位",
        duty: "离休时职务",
        petireddate: "离休时间",
        treatment: "校正后待遇（规范）",
        medical: "医疗待遇",
        // organizationid: 15,
        organization: "现管单位",
        belongname: "归属",
        street:"居住街道",
        category: "类别",
        alive: "是否健在",
        deathdate: "已故时间",
        // photo: "/image/avatar/73d556fc-2569-4a04-bc17-13db0e3a07af.jpg",
        // extendid: 3,
        // cadreid: null,
        partgroup: "所在基层党组织",
        mobile: "手机号",
        telephone: "座机号",
        address: "居住地址",
        buffet: "助餐情况",
        insurance: "长护险参与情况",
        company: "服务公司名称",
        health: "近期健康状况",
        lonely: "是否孤老",
        live: "居住情况",

        children: "子女情况",
        homenanny: "是否有居家保姆",
        hourlyworker: "是否有钟点工",

        // agency: null,
        // contacts: [
        //   {
        //     id: 22,
        //     extendid: 3,
        //     name: "儿子",
        //     relationship: "子女",
        //     tel: "123123213123123",
        //     address: "上海虹口区xx街道",
        //   },
        // ],
      },

      totalNum: 0,
      saveNum: 0,
      errorNum: 0,
    };
  },

  mounted() {
    this.initNation();
    this.initOrganzation();
  },

  methods: {
    //民族列表
    initNation() {
      this.$axios
        .get("/cadresInfo/nation")
        .then((Response) => {
          const { data } = Response;
          this.nations = data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 获取组织机构列表
    initOrganzation() {
      this.$axios
        .get("/cadresInfo/orgList")
        .then((response) => {
          const { data } = response;
          this.organizations = data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    httpRequest(e) {
      this.cadresInfo = [];
      let that = this;
      let file = e.file; // 文件信息
      if (!file) {
        // 没有文件
        return false;
      } else if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
        // 判断是否excel格式
        that.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }
      this.fileloading = true;
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary", // 以字符编码的方式解析
            // cellDates: true
          });
          const exlname = workbook.SheetNames[0]; // 取第一张表
          console.log(workbook.Sheets[exlname]);
          const exl = XLSX.utils.sheet_to_json(workbook.Sheets[exlname]); // 生成json表格内容

          this.cadresInfo = this.parseToCadresInfo(exl);
          this.totalNum = this.cadresInfo.length;
          this.fileloading = false;
        } catch (e) {
          this.fileloading = false;
          this.$message.error("文件读取出错，或者文件内容格式不正确！");
          console.log(e);
          console.log("出错了");
          return false;
        }
      };
      fileReader.readAsBinaryString(file);
    },

    //将excel读取的数据转换为cadres对象
    parseToCadresInfo(jsonSheet) {
      let cadreList = [];
      // 遍历对象
      jsonSheet.forEach((item) => {
        let cadreInfo = {};
        // 处理基础的映射关系
        Object.keys(this.keyOfcolName).forEach((key) => {
          let colName = this.keyOfcolName[key];
          cadreInfo[key] = item[colName] || null;
        });

        //民族转换
        cadreInfo["nation"] = this.parseNationNameToID(cadreInfo.nationname);

        //组织机构转换
        cadreInfo["organizationid"] = this.praseOrgNameToID(
          cadreInfo.organization
        );

        //街道转换
        cadreInfo["streetid"] = this.praseStreetNameToID(
          cadreInfo.street
        );

        //全角处理
        if (cadreInfo.belongname) {
          cadreInfo.belongname = cadreInfo.belongname
            .replace("（", "(")
            .replace("）", ")");
        }
        cadreInfo.belonging = this.praseBelonging(cadreInfo.belongname);

        //日期转换
        let birthday = cadreInfo.birthday;
        cadreInfo.birthday = birthday ? changeDate(birthday) : null;

        let partydate = cadreInfo.partydate;
        cadreInfo.partydate = partydate ? changeDate(partydate) : null;

        let workdate = cadreInfo.workdate;
        cadreInfo.workdate = workdate ? changeDate(workdate) : null;

        let petireddate = cadreInfo.petireddate;
        cadreInfo.petireddate = petireddate ? changeDate(petireddate) : null;

        let deathdate = cadreInfo.deathdate;
        cadreInfo.deathdate = deathdate ? changeDate(deathdate) : null;

        // 处理养老机构
        let agency = {
          type: item["养老机构类型"] || "",
          name: item["机构名称"] || "",
          tel: item["机构电话"] || "",
          department: item["诊疗科室"] || "",
          address: item["机构地址"] || "",
        };
        // 必须有名称，否则视为无效数据
        if (agency.name) {
          cadreInfo["agency"] = agency;
        } else {
          cadreInfo["agency"] = null;
        }

        // 处理联系人
        let contact = {
          id: null,
          extendid: null,
          name: item["联系人姓名"] || null,
          relationship: item["关系"] || "子女",
          tel: item["联系人电话"] || null,
          address: item["联系人地址"] || null,
        };

        // 姓名和电话必须有一个,否则视为无效数据
        if (contact.name || contact.tel) {
          cadreInfo["contacts"] = [contact];
        } else {
          cadreInfo["contacts"] = [];
        }

        //处理长护险
        if (cadreInfo.insurance == 1) {
          cadreInfo.insurance = "享受";
        }

        // 处理其他字段
        cadreInfo["id"] = null;
        cadreInfo["extendid"] = null;
        cadreInfo["cadreid"] = null;

        //添加一个上传标志
        cadreInfo["IsSaved"] = undefined;

        cadreList.push(cadreInfo);
      });

      return cadreList;
    },

    //将民族转为代码
    parseNationNameToID(nationName) {
      if (!nationName) {
        return null;
      }
      let id = null;
      for (var nation of this.nations) {
        if (nation.name == nationName) {
          id = nation.id;
          break;
        }
      }
      return id;
    },

    // 将组织名转为代码
    praseOrgNameToID(orgName) {
      if (!orgName) {
        return null;
      }
      let id = null;
      for (var organization of this.organizations) {
        if (organization.name == orgName) {
          id = organization.id;
          break;
        }
      }
      return id;
    },

    praseStreetNameToID(streetName){
       if (!streetName) {
        return null;
      }
      let id = null;
      for (var street of this.organizations) {
        if (street.name == streetName) {
          id = street.id;
          break;
        }
      }
      return id;
    },

    praseBelonging(belongname) {
      if (belongname == "区属(住外区)") {
        return "1";
      } else if (belongname == "区属(住本区)") {
        return "2";
      } else if (belongname == "社区(非区属)") {
        return "3";
      }

      return null;
    },

    //保存信息列表
    savelist() {
      this.saveNum = 0;
      this.errorNum = 0;
      for (var info of this.cadresInfo) {
        if (info.IsSaved == true) {
          continue;
        }
        info.agency = JSON.stringify(info.agency);
        this.saveCadresInfo(info);
      }
    },
    //保存单个老干部信息
    saveCadresInfo(cadresInfo) {
      this.$axios
        .post("/cadresInfo", cadresInfo)
        .then((response) => {
          if (response.data.code == "200") {
            this.saveNum += 1;
            cadresInfo.IsSaved = true;
          } else {
            this.errorNum += 1;
            cadresInfo.IsSaved = false;
            this.$message.error("保存失败");
          }
        })
        .catch((error) => {
          this.errorNum += 1;
          cadresInfo.IsSaved = false;
          console.log(error);
        });
    },
  },
};
</script>